import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAllUsers } from 'state/reducers/user.reducers';
import { useAppDispatch } from 'hooks/redux.hooks';
import { getSites } from 'state/reducers/site.reducers';
import { getAllCps } from 'state/reducers/cp.reducers';
import { getPatients } from 'state/reducers/patients.reducers';

export enum DataFetchKeys {
  CPS = 'cps',
  PATIENTS = 'patients',
  SITES = 'sites',
  USERS = 'users'
}

interface DataFetchContextProps {
  loadDataByKeys: (keys: DataFetchKeys[]) => void;
}

const DataFetchContext = createContext<DataFetchContextProps>({
  loadDataByKeys: () => {}
});

interface IDataFetchProvider {
  children?: React.ReactNode;
}

export const DataFetchProvider: React.FC<IDataFetchProvider> = ({ children }) => {
  const dispatch = useAppDispatch();

  const loadDataByKeys = (keys: DataFetchKeys[]) => {
    keys.forEach((key) => {
      switch (key) {
        case DataFetchKeys.CPS:
          dispatch(getAllCps({}));
          break;
        case DataFetchKeys.PATIENTS:
          dispatch(getPatients());
          break;
        case DataFetchKeys.SITES:
          dispatch(getSites());
          break;
        case DataFetchKeys.USERS:
          dispatch(getAllUsers());
          break;
        default:
          break;
      }
    });
  };

  return <DataFetchContext.Provider value={{ loadDataByKeys }}>{children}</DataFetchContext.Provider>;
};

export default DataFetchProvider;

export const useDataFetchContext = () => useContext(DataFetchContext);
